// extracted by mini-css-extract-plugin
export default {"error__container":"InputError_error__container__bf++3","error__message":"InputError_error__message__X4AS6"};